// Request/response shapes shared by apps/api and apps/web (docs/contract.md §5–§7).
import { FUNCTION_IDS } from './catalog.js';
/** Review sections that take a Discovery Session note: each tools-map row, then the side cards. */
export const NOTE_SECTIONS = [...FUNCTION_IDS, 'flags', 'questions', 'scope'];
/** Longest note body, in characters. */
export const NOTE_MAX = 10_000;
//# sourceMappingURL=api.js.map